import React, { useEffect, useState } from "react";
import BuyCreditsModal from "./BuyCreditsModal";
import { useAuth } from "../contexts/AuthContext";

const DISMISS_KEY = "lowCreditsPopupDismissedAt";

/**
 * Mounted once near the app root. Listens for the "low-credits-popup" event
 * (dispatched by lib/api.js whenever a response carries the low-balance
 * signal header — i.e. right after any AI-charging feature runs) and shows
 * the Buy Credits modal. Shown once per browser session until dismissed.
 */
export default function LowCreditsAutoPopup() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [balance, setBalance] = useState(null);

  const isStaff = !!(user && user !== false && user.companyId);

  useEffect(() => {
    const handler = (e) => {
      if (sessionStorage.getItem(DISMISS_KEY)) return;
      setBalance(e.detail?.balance);
      setOpen(true);
    };
    window.addEventListener("low-credits-popup", handler);
    return () => window.removeEventListener("low-credits-popup", handler);
  }, []);

  if (!isStaff || !open) return null;

  const balText = balance != null ? Math.max(0, Math.floor(balance)) : null;

  return (
    <BuyCreditsModal
      open={open}
      onClose={() => {
        setOpen(false);
        sessionStorage.setItem(DISMISS_KEY, "1");
      }}
      banner={
        balText != null
          ? `You have ${balText.toLocaleString()} AI credits left. To keep using AI features you will need to purchase more credits.`
          : "To keep using AI features you will need to purchase more credits."
      }
    />
  );
}
